import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import cacheStorage from '../utils/cacheStorage';

function getRole() {
    const token = cacheStorage.getItem('id_token');
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded['https://SmartCargo/roles']?.[0] || null;
    } catch {
        return null;
    }
}

function getHomePath(role) {
    if (role === 'courier') return '/courier';
    if (role === 'admin' || role === 'master admin') return '/admin';
    return '/';
}

export default function AccessDenied() {
    const location = useLocation();
    const role = getRole();
    const homePath = getHomePath(role);

    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <h1 style={styles.title}>Access Denied</h1>
                <p style={styles.text}>
                    You do not have permission to open this page.
                </p>

                {location.state?.attemptedPath && (
                    <p style={styles.small}>
                        Attempted page: <strong>{location.state.attemptedPath}</strong>
                    </p>
                )}

                <div style={styles.actions}>
                    <Link to={homePath} style={styles.primaryBtn}>
                        Go back
                    </Link>
                    <Link to="/" style={styles.secondaryBtn}>
                        Login page
                    </Link>
                </div>
            </div>
        </div>
    );
}

const styles = {
    wrapper: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f6fa',
        padding: '24px',
    },
    card: {
        width: '100%',
        maxWidth: '480px',
        background: '#ffffff',
        borderRadius: '16px',
        padding: '32px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
        textAlign: 'center',
    },
    title: {
        margin: '0 0 12px',
        color: '#b91c1c',
        fontSize: '32px',
    },
    text: {
        margin: '0 0 12px',
        color: '#334155',
        fontSize: '16px',
    },
    small: {
        margin: '0 0 20px',
        color: '#64748b',
        fontSize: '14px',
    },
    actions: {
        display: 'flex',
        gap: '12px',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginTop: '8px',
    },
    primaryBtn: {
        textDecoration: 'none',
        background: '#2D58AD',
        color: '#fff',
        padding: '10px 18px',
        borderRadius: '10px',
        fontWeight: 600,
    },
    secondaryBtn: {
        textDecoration: 'none',
        background: '#e2e8f0',
        color: '#0f172a',
        padding: '10px 18px',
        borderRadius: '10px',
        fontWeight: 600,
    },
};